import type { FieldTypeTemplate } from '#layers/data-model/types/field-types/field-type';
import boolean from './definitions/boolean';
import color from './definitions/color';
import datetime from './definitions/datetime';
import file from './definitions/file';
import identifier from './definitions/identifier';
import json from './definitions/json';
import number from './definitions/number';
import relation from './definitions/relation';
import select from './definitions/select';
import slug from './definitions/slug';
import text from './definitions/text';

const fieldTypes = { boolean, color, datetime, file, identifier, json, number, relation, select, slug, text };

const mappedTypes = Object.fromEntries(Object.values(fieldTypes as unknown as Record<string, FieldTypeTemplate>).map((type) => [type.id, type]));

export default mappedTypes;
